import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Stack, Heading, Bleed, Box } from "braid-design-system";
import { useMemo } from "react";
import { useJobDetailsViewContext } from "../CompanyProfile/CompanyProfile.mjs";
import { getPaddingX } from "../JDVLayout/JDVLayout.mjs";
import { translations } from "../../../components/CompetitiveJobs/.vocab/index.mjs";
import { CompetitiveJobCard } from "./CompetitiveJobCard.mjs";
import { CompetitiveJobsSkeleton } from "./CompetitiveJobsSkeleton.mjs";
import { horizontalScrollOnTablet } from "./CompetitiveJobs.css.mjs";
const CompetitiveJobs = ({
  jobs = [],
  isLoadingCompetitiveJobs
}) => {
  const isEnableHorizontalScroll = jobs.length === 3;
  const { t } = useTranslations(translations);
  const { embedded } = useJobDetailsViewContext();
  const jdvPaddingXForTablet = useMemo(() => {
    const jdvPaddingX = getPaddingX({
      embedded
    });
    return typeof jdvPaddingX === "object" ? jdvPaddingX.tablet : jdvPaddingX || "none";
  }, [embedded]);
  if (isLoadingCompetitiveJobs) {
    return /* @__PURE__ */ jsx(CompetitiveJobsSkeleton, {});
  }
  return /* @__PURE__ */ jsxs(Stack, { space: "large", data: { testid: "competitive-jobs" }, children: [
    /* @__PURE__ */ jsx(Heading, { level: "4", children: t("Featured jobs", { jobCount: jobs.length }) }),
    /* @__PURE__ */ jsx(
      Bleed,
      {
        horizontal: {
          mobile: "none",
          tablet: isEnableHorizontalScroll ? jdvPaddingXForTablet : "none",
          desktop: "none"
        },
        children: /* @__PURE__ */ jsx(
          Box,
          {
            display: "flex",
            gap: "small",
            flexDirection: { mobile: "column", tablet: "row" },
            width: "full",
            className: {
              [horizontalScrollOnTablet]: isEnableHorizontalScroll
            },
            paddingLeft: {
              tablet: isEnableHorizontalScroll ? jdvPaddingXForTablet : "none",
              desktop: "none"
            },
            children: jobs.map((props, index) => /* @__PURE__ */ jsx(
              CompetitiveJobCard,
              {
                isEnableHorizontalScroll,
                wrapperPaddingRight: {
                  tablet: isEnableHorizontalScroll && index === jobs.length - 1 ? jdvPaddingXForTablet : "none",
                  desktop: "none"
                },
                id: props.id,
                pos: index + 1,
                title: props.title,
                advertiserName: props.company.name,
                locationLabel: props.location,
                listingDateLabel: props.postedDateFormatted,
                srcLogo: props.srcLogo,
                solMetadata: props.solMetadata,
                solHash: props.solHash
              },
              index
            ))
          }
        )
      }
    )
  ] });
};
export {
  CompetitiveJobs
};
